









































import { DiscountRate } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import discountRateService from "@/service/discountRateService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class DiscountRateDeleteDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: DiscountRate = discountRateService.defaultDiscountRate;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: DiscountRate): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  private deleteItem(): void {
    this.isProgressing = true;
    //delete
    discountRateService
      .deleteDiscountRate(this.item)
      .then((result) => {
        this.isProgressing = false;
        this.notifySuccess(result as DiscountRate);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: DiscountRate): DiscountRate {
    return deleted;
  }
}
